import axios from "axios";

const WC_ID = "cdkedkk4s26fsmnkhrhg";

export const worldCupRankingsRequest = async () => {
  const ranking: any = await axios.get(`/v1/competitions/${WC_ID}/ranking`);

  if (ranking && ranking.competition_ranking) {
    ranking.competition_ranking.sort(
      (a: any, b: any) => a.position - b.position
    );
  }
  return ranking;
};
